<template>
    <div>
        <!-- 搜索按钮 -->
        <div ref="div" @click="SearchTerms($event)" :style="{top:top+'px',left:left+'px'}" class="Wordmain">
            <div class="Wordmainh" v-if="isCheck">
                <!-- <Icon style="color:rgb(6, 84, 148);font-size: 18px; margin:0 5px 0 2px ; " type="ios-search" /> -->
                <span><img src="@/assets/img/details/fdj.png" alt=""></span>
                <span>词典检索</span>
            </div>
                    <!-- 搜索内容 -->
            <div :style="{right:newRight+'px',top:newTop+'px'}" v-if="!isCheck" class="conent">
                <div @click="close" class="tgb">
                    <img src="@/assets/img/details/guanbi.png" alt="">
                </div>
                <!-- 标题 -->
                <div class="h">
                    <div>{{text}}</div>
                    <div>{{PyText}}</div>
                </div>
                <!-- 内容 -->
                <div class="conent-1">
                <Row v-show="state === 1">
                    <Col class="demo-spin-col" span="8">
                        <Spin fix>
                            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                            <div>正在检索</div>
                        </Spin>
                    </Col>
                </Row>
                <div v-show="state == 2">
                    <!-- <div v-html="XMLabstract1"></div> -->
                    <p v-for="xml,index in XMLabstract" :key="'xml-'+index">
                        <span>{{xml._}}</span>
                        <span v-for="example,index in xml.example" :key="'example'+index">{{example}}</span>
                        <span v-for="xml1,index in xml.citation" :key="'xml1-'+index">
                                <span v-if="xml1.author">{{xml1.author[0]}}</span>
                                <span v-for="xml2,index in xml1.fullbookname" :key="'xml2-'+index">
                                    <span v-for="xml3,index in xml2.bookname" :key="'xml3-'+index">
                                        &nbsp;<span>《&nbsp;{{xml3}}&nbsp;》</span>
                                    </span>
                                    <span v-for="xml4,index in xml1.content" :key="'xml4-'+index">
                                        <span>{{xml4}}</span>
                                    </span>
                                </span>
                        </span>
                    </p>
                </div>
                <div class="null" v-show="state === 3">暂无释义</div>
                </div>
                <!-- <div v-show="state == 2" class="docSource">{{docSource}}{{docSources}}</div> -->
                <!-- <div v-show="state == 2" class="docSource"><span style="color:#0095ff;">来源: </span>{{docSource}}</div> -->
            </div>
        </div>

    </div>
</template>

<script>
const { pinyin } = require('pinyin-pro');
const { parseString } = require('xml2js');
export default {
    name:'LookUpTheWord',
    props:['coord'],
    data(){
        return{
            top:this.coord.y+this.getScrollOffset().y,//鼠标Y坐标
            left:this.coord.x,
            isCheck:true,//控制元素隐藏显示
            text:this.coord.text, //拿到父组件传递的文本
            PyText:'', //拼音
            state:null, //检索状态 1加载中 2检索成功 3检索失败
            // abstract:'', //不带格式的词义
            XMLabstract:[
            ], //带格式词义
            docSource:'', //来源
            docSources:'', //来源
            // XMLabstract1:''
      }
    },
    watch:{
        // 点击查询是请求接口
        isCheck(){
            if (!this.isCheck) {
                    this.getDictionary({
                    word:this.text
                }) 
            }
        }
    },
    computed:{
        //计算出元素离右侧的距离
        conentRright(){
            console.log('偏移量:',this.getScrollOffset())
            let reight //初始值
            reight = window.innerWidth-this.getOffset(this.$refs.div)[0]-590
            return reight
        },
        //计算出右侧偏移量
        newRight(){
            let newRight
            if(this.conentRright<20){
               newRight=590
            }
            return newRight
        },
        //计算出top偏移量
        newTop(){
            let newTop
            if(this.conentRright<20){
              newTop=20
            }
            return newTop
        }
    },
    methods:{
        // 计算出偏移量
        getScrollOffset() {
            if (window.pageXOffset) {
                return {
                    x: window.pageXOffset,
                    y: window.pageYOffset
                }
            } else {
                return {
                    x: document.body.scrollLeft + document.documentElement.scrollLeft,
                    y: document.body.scrollTop + document.documentElement.scrollTop
                }
            }
        },
        //计算出元素距离视窗的位置
        getOffset(obj){
            var arr=[]
            var offsetL=0
            var offsetT=0
            while(obj!=window.document.body&&obj!=null)
            {
                offsetL+=obj.offsetLeft
                offsetT+=obj.offsetTop
                obj=obj.offsetParent
            }
            arr.push(offsetL,offsetT)
            return arr
        },
        // 搜索词条
        SearchTerms(){
            this.isCheck=false
        },
        //关闭检索内容
        close(){
            this.$emit('CloseToRetrieve') //传递事件,用于关闭检索
        },
        // 调接口
        async getDictionary(word){
            this.state = 1
            this.PyText = pinyin(this.text)
            const resp = await this.$apis.searchServe.getDictionary(word);
           this.ds = setTimeout(()=>{
                console.log('进入定时器')
                if(resp.data.content[0]){
                    console.log('进入判断')
                    this.XMLabstract1 = resp.data.content[0].docExplain
                    this.docSource = resp.data.content[0].docProvider
                    this.docSources = resp.data.content[0].docSource
                    parseString(resp.data.content[0].docXml,(err, content)=>{
                        console.log(content,'格式化')
                        let XMLObj = JSON.parse(JSON.stringify(content, null, 4))
                        if(XMLObj.entry.definition[0].section[0].sense){
                            this.XMLabstract = XMLObj.entry.definition[0].section[0].sense
                        }
                    })
                    this.state = 2
                }else{
                    this.state = 3
                }
            },350)

        }

    },
    mounted(){
        // console.log(this.coord.text)
        // console.log('X',this.coord.x)
        // console.log('Y',this.coord.y)
        // console.log(this.getScrollOffset())
    },
    beforeDestroy() {
        clearInterval(this.clearTimeSet); //清除定时器
    },
};
</script>

<style lang="scss" scoped>
.Wordmain{
    width: 90px;
    height: 24px;
    position: absolute;
}
.Wordmainh{
    border: 1px solid #A3CBE7;
    border-radius: 4px;
    box-shadow: 2px 1px 5px #888888;
    position: relative;
    left: 5px;
    background: #fff;
    cursor:pointer;
}
.Wordmain span{
    color: #000;
    font-size: 14px;
}
.Wordmain img{
    width: 15px;
    height: 15px;
    position: relative;
    top: 2px;
    margin-right: 5px;
    margin-left: 5px;
}
.conent{
    width: 590px;
    background: rgb(252, 252, 252);
    box-shadow: 0px 3px 9px 1px rgba(22, 24, 60, 0.26);
    border-radius: 4px;
    position: relative;
    line-height: 30px;
    padding: 4px 36px 34px 36px;
    top: 10px;
    color: rgb(0, 0, 0);
    .h{
        float: left;
        width: 590px;
        :nth-child(1){
            font-family:PingFangSC-Regular;
        }
        // margin-bottom: 30px;
    }
    .h :nth-child(1){
        float: left;
        font-size: 17px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .h :nth-child(2){
        float: left;
        margin-left: 30px;
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-height: 600px;
        overflow-y: auto;

    }
    .conent-1{
        width: 522px;
        max-height:200px;
        overflow:auto;
        position: relative;
        top: 25px;
        margin-bottom: 15px;
        .null{
            text-align: center;
            font-size: 14px;
        }
    }
    .tgb{
        width: 26px;
        height: 26px;
        position: relative;
        top: -6px;
        left: 529px;
        border-top-right-radius: 4px;
        // background-image: url(../../assets/img/qietu/del.png);
        // background-size: 27px;
        cursor:pointer;
        & img{
            width: 20px;
            height: 20px;
        }
        
    }
    .docSource{
        text-align: right;
        position: relative;
        top: 25px;
        right: 0;
    }
}
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }
    @keyframes ani-demo-spin {
        from { transform: rotate(0deg);}
        50%  { transform: rotate(180deg);}
        to   { transform: rotate(360deg);}
    }
    .demo-spin-col{
        height: 100px;
        position: relative;
        margin: 0 auto;

    }
    ::v-deep .ivu-spin-fix{
        background: #fcfcfc;
    }
</style>
